import React, { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { DoorwayLanding } from "@/components/explore/DoorwayLanding";
import { ConnectionsHub } from "@/components/explore/ConnectionsHub";
import { MapView } from "@/components/explore/MapView";

// /explore orchestrates three lenses:
//   default            -> Doorway Landing (curated entry cards)
//   ?node=<id>         -> Connections Explorer hub page
//   ?view=map[&node]   -> interactive graph (Map)
//   ?view=timeline     -> chronological Timeline
// Legacy deep-links (?focus=<id>) are treated as ?node=<id>.
export default function Explore() {
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get("view");
  const nodeId = searchParams.get("node") || searchParams.get("focus");

  const openNode = useCallback(
    (id) => {
      setSearchParams(id ? { node: id } : {});
    },
    [setSearchParams]
  );

  if (view === "map" || view === "timeline") {
    return <MapView />;
  }
  if (nodeId) {
    return <ConnectionsHub nodeId={nodeId} onOpenNode={openNode} />;
  }
  return <DoorwayLanding onOpenNode={openNode} />;
}
